import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { ModifiersShape } from 'react-dates';
import i18n from '../../R/string/i18n';

const CalendarDayContent = ({
  day,
  modifiers,
  calendarPrice,
  isLoadingCalendar,
}: {
  day: moment.Moment;
  modifiers: ModifiersShape;
  calendarPrice?: string;
  isLoadingCalendar: boolean;
}) => {
  const isSelectedDate =
    modifiers.has('selected-start') ||
    modifiers.has('selected-span') ||
    modifiers.has('selected-end');

  return (
    <React.Fragment>
      <div className="calendar-date">{day.date()}</div>
      <div
        className={classNames('calendar-price', {
          'is-loading': isLoadingCalendar,
          selected: isSelectedDate,
        })}
      >
        {isLoadingCalendar ? i18n.webYadoCalendarLoading() : calendarPrice}
      </div>

      <style jsx>
        {`
          .calendar-date {
            font-size: 14px;
            font-weight: bold;
          }
          .calendar-price {
            font-size: 12px;
            font-weight: bold;
            color: #9b9b9b;
          }
          .calendar-price.is-loading {
            font-weight: 400;
            opacity: 0.7;
          }
          .calendar-price.selected {
            color: #ffffff;
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default CalendarDayContent;
